import React from 'react';
import { BsFillRecordFill } from "react-icons/bs";
import { FiStopCircle } from "react-icons/fi";

// --- 1. START RECORDING INSTRUCTION MODAL ---
export const StartRecordingModal = ({ isOpen, onClose, onStart }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[10000] p-4">
      <div className="bg-gray-800 border border-blue-500/30 p-8 rounded-2xl max-w-md w-full shadow-2xl text-center">
        <div className="w-16 h-16 bg-blue-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <BsFillRecordFill className="h-8 w-8 text-red-500 animate-pulse" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">Recording Instructions</h2>
        <div className="text-gray-300 text-sm space-y-4 mb-8 text-left bg-gray-900/50 p-4 rounded-lg">
          <p>• <strong>One-Time Start:</strong> Recording can only be started <strong>once</strong> per session. If you stop, you must reload the page to record again.</p>
          <p>• <strong>To Save:</strong> After stopping the recording, you <strong>must</strong> click the "End Session" button to process and save your file.</p>
          <p>• <strong>System Audio:</strong> Ensure you share the 'System Audio' in the browser popup for better sound quality.</p>
        </div>
        <div className="flex gap-3">
          <button 
            onClick={onClose}
            className="flex-1 px-4 py-3 bg-gray-700 hover:bg-gray-600 rounded-xl font-medium transition-all text-white"
          >
            Cancel
          </button>
          <button 
            onClick={() => {
              onClose();
              onStart();
            }}
            className="flex-1 px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold transition-all"
          >
            I Understand, Start
          </button>
        </div>
      </div>
    </div>
  );
};

// --- 2. STOP RECORDING CONFIRMATION MODAL ---
export const StopRecordingModal = ({ isOpen, onClose, onStop }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[10000] p-4">
      <div className="bg-gray-800 border border-red-500/30 p-8 rounded-2xl max-w-sm w-full shadow-2xl text-center">
        <div className="w-16 h-16 bg-red-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <FiStopCircle className="h-8 w-8 text-red-400" />
        </div>
        <h2 className="text-xl font-bold text-white mb-2">Stop Recording?</h2>
        <p className="text-gray-400 text-sm mb-8">
          Are you sure you want to stop the recording? You won't be able to start it again without refreshing the session.
        </p>
        <div className="flex gap-3">
          <button 
            onClick={onClose}
            className="flex-1 px-4 py-3 bg-gray-700 hover:bg-gray-600 rounded-xl font-medium transition-all text-white"
          >
            No, Continue
          </button>
          <button 
            onClick={() => {
              onClose();
              onStop();
            }}
            className="flex-1 px-4 py-3 bg-red-600 hover:bg-red-700 text-white rounded-xl font-bold transition-all"
          >
            Yes, Stop
          </button>
        </div>
      </div>
    </div>
  );
};